module.exports = __webpack_public_path__ + "media/images/en_flag-616a62aaf8a06b0fd0a8d49b55167f79.svg";